/**
 * @author Jorge Casas
 * @creationDate 03/07/2024
 */

import { createReport } from 'docx-templates';
import fetch from 'node-fetch';

/**
 * @function generateCodesLabelByAssetDocx
 * 
 * @description Function to generate a DOCX with the QR and Barcode of an asset
 * 
 * @param {string} qrUrl - The URL of the QR code
 * @param {string} barcodeUrl - The URL of the Barcode
 * @param {string} assetNumber - The number of the asset
 * @returns {Promise} - The DOCX with the QR and Barcode
 * @throws {Promise} - The error message
 */
export const generateCodesLabelByAssetDocx = async (qrUrl, barcodeUrl, assetNumber) => {
  try {
    let qrCodeBase64 = '';
    let barcodeBase64 = '';

    if (qrUrl && qrUrl !== '') {
      const qrResponse = await fetch(qrUrl);
      if (!qrResponse.ok) throw new Error('Error fetching QR image');
      const qrBuffer = await qrResponse.arrayBuffer();
      qrCodeBase64 = Buffer.from(qrBuffer).toString('base64');
    }

    if (barcodeUrl && barcodeUrl !== '') {
      const barcodeResponse = await fetch(barcodeUrl);
      if (!barcodeResponse.ok) throw new Error('Error fetching Barcode image');
      const barcodeBuffer = await barcodeResponse.arrayBuffer();
      barcodeBase64 = Buffer.from(barcodeBuffer).toString('base64');
    }

    const codesLabel = {
      images: {
        qrCode: {
          data: qrCodeBase64,
          width: 3,
          height: 3,
          extension: '.png',
        },
        barcode: {
          data: barcodeBase64,
          width: 9,
          height: 1.5,
          extension: '.png',
        },
      },
    };

    const templateResponse = await fetch(
      'https://controlactivofijo.s3.us-east-2.amazonaws.com/templates/assets/assets.docx'
    );
    if (!templateResponse.ok) throw new Error('Error fetching DOCX template');
    const templateBuffer = await templateResponse.arrayBuffer();

    const report = await createReport({
      template: templateBuffer,
      data: codesLabel,

      outputType: Uint8Array,
    });

    const blob = new Blob([report], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
    const downloadUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = `${assetNumber}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    console.log('DOCX report generated and downloaded successfully');
  } catch (error) {
    console.error('Error generating DOCX:', error);
    throw new Error('Error generating DOCX');
  }
};



// WEBPACK FOOTER //
// src/lib/documents/AssetsCodesLabel.js